export const ROUTES = {
  MAIN_PATH: '/help',
  BAI_PATH: '/help-bai',
  BOOKKEEPER_PATH: '/bookkeeper/help',
};
